<a class="fw-bold text-gray-900 d-flex gap-2 align-items-center cursor-pointer">
  <ui-keenicon [name]="icon()" [class]="iconClass()"></ui-keenicon>
  <span
    class="text-gray-800 d-flex gap-1 flex-wrap text-hover-primary cursor-pointer"
    >{{ text() }}</span
  >
</a>
